// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file gov_dash_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AiVerification, AiVerificationByJobRequestSchema, AiVerificationJson, AiVerificationListRequestSchema, AiVerificationSchema } from "./ai_verification_pb";
import { file_ai_verification } from "./ai_verification_pb";
import type { ContainerGroup, ContainerGroupJson, ContainerTypeListSchema } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { Contract, ContractJson } from "./contract_pb";
import { file_contract } from "./contract_pb";
import type { DailySummary, DailySummaryJson } from "./daily_summary_pb";
import { file_daily_summary } from "./daily_summary_pb";
import type { DriverOnShift, DriverOnShiftJson, DriverOnShiftListSchema } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { DriverOnShiftStatus, DriverOnShiftStatusJson, JobCategory, JobCategoryJson, JobStatus, JobStatusJson, JobType, JobTypeJson, LocationStatus, LocationStatusJson, RouteCategory, RouteCategoryJson, RouteStatus, RouteStatusJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateTimeFilter, DateTimeFilterJson, EmptyMessageRequestSchema, IdRequestSchema, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { GovGeoAccessListSchema } from "./gov_geo_access_pb";
import { file_gov_geo_access } from "./gov_geo_access_pb";
import type { GpsStop, GpsStopJson, GpsStopListSchema } from "./gps_tables_pb";
import { file_gps_tables } from "./gps_tables_pb";
import type { Job, JobJson, JobListSchema, JobSchema } from "./job_pb";
import { file_job } from "./job_pb";
import type { Location, LocationCreateSchema, LocationJson, LocationListSchema, LocationSchema, LocationUpdateSchema } from "./location_pb";
import { file_location } from "./location_pb";
import type { Organization, OrganizationJson, OrganizationListSchema, OrganizationSchema } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { Route, RouteJson, RouteListSchema } from "./route_pb";
import { file_route } from "./route_pb";
import type { RawScaleRecordListResponseSchema } from "./scale_service_pb";
import { file_scale_service } from "./scale_service_pb";
import type { Truck, TruckJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file gov_dash_service.proto.
 */
export const file_gov_dash_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_ai_verification, file_container_group, file_contract, file_daily_summary, file_driver_on_shift, file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_gov_geo_access, file_gps_tables, file_job, file_location, file_organization, file_pickup_location, file_route, file_scale_service, file_truck]);

/**
 * @generated from message raccoonai.GovOrganizationRequest
 */
export type GovOrganizationRequest = Message<"raccoonai.GovOrganizationRequest"> & {
  /**
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  districtOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];
};

/**
 * @generated from message raccoonai.GovOrganizationRequest
 */
export type GovOrganizationRequestJson = {
  /**
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  district_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];
};

/**
 * Describes the message raccoonai.GovOrganizationRequest.
 * Use `create(GovOrganizationRequestSchema)` to create a new message.
 */
export const GovOrganizationRequestSchema: GenMessage<GovOrganizationRequest, {jsonType: GovOrganizationRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 0);

/**
 * @generated from message raccoonai.GovJobListRequest
 */
export type GovJobListRequest = Message<"raccoonai.GovJobListRequest"> & {
  /**
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  districtOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated uint64 service_receiver_ids = 3 [json_name = "service_receiver_ids"];
   */
  serviceReceiverIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 4 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * @generated from field: repeated raccoonai.JobCategory job_categories = 5 [json_name = "job_categories"];
   */
  jobCategories: JobCategory[];

  /**
   * @generated from field: repeated raccoonai.JobStatus job_statuses = 6 [json_name = "job_statuses"];
   */
  jobStatuses: JobStatus[];

  /**
   * @generated from field: optional uint64 driver_id = 7 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 9 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 10 [json_name = "time_filter"];
   */
  timeFilter?: DateTimeFilter;

  /**
   * Free-text search, matched against pickup location name (more fields may
   * be added later - see JobService.GovListJobs).
   *
   * @generated from field: optional string search = 11;
   */
  search: string;

  /**
   * Specific jobs by id, still narrowed to the caller's geo access. This is how a
   * review queue built from ListAiVerifications fetches the flagged jobs
   * themselves — the response carries each job's ai_verification.
   *
   * @generated from field: repeated uint64 job_ids = 12 [json_name = "job_ids"];
   */
  jobIds: bigint[];
};

/**
 * @generated from message raccoonai.GovJobListRequest
 */
export type GovJobListRequestJson = {
  /**
   * @generated from field: repeated uint64 district_organization_ids = 1 [json_name = "district_organization_ids"];
   */
  district_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_provider_ids = 2 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated uint64 service_receiver_ids = 3 [json_name = "service_receiver_ids"];
   */
  service_receiver_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 4 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * @generated from field: repeated raccoonai.JobCategory job_categories = 5 [json_name = "job_categories"];
   */
  job_categories?: JobCategoryJson[];

  /**
   * @generated from field: repeated raccoonai.JobStatus job_statuses = 6 [json_name = "job_statuses"];
   */
  job_statuses?: JobStatusJson[];

  /**
   * @generated from field: optional uint64 driver_id = 7 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 9 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * @generated from field: optional raccoonai.DateTimeFilter time_filter = 10 [json_name = "time_filter"];
   */
  time_filter?: DateTimeFilterJson;

  /**
   * Free-text search, matched against pickup location name (more fields may
   * be added later - see JobService.GovListJobs).
   *
   * @generated from field: optional string search = 11;
   */
  search?: string;

  /**
   * Specific jobs by id, still narrowed to the caller's geo access. This is how a
   * review queue built from ListAiVerifications fetches the flagged jobs
   * themselves — the response carries each job's ai_verification.
   *
   * @generated from field: repeated uint64 job_ids = 12 [json_name = "job_ids"];
   */
  job_ids?: string[];
};

/**
 * Describes the message raccoonai.GovJobListRequest.
 * Use `create(GovJobListRequestSchema)` to create a new message.
 */
export const GovJobListRequestSchema: GenMessage<GovJobListRequest, {jsonType: GovJobListRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 1);

/**
 * @generated from message raccoonai.GovJobsReportResponse
 */
export type GovJobsReportResponse = Message<"raccoonai.GovJobsReportResponse"> & {
  /**
   * @generated from field: required bytes content = 1;
   */
  content: Uint8Array;

  /**
   * @generated from field: required string filename = 2;
   */
  filename: string;
};

/**
 * @generated from message raccoonai.GovJobsReportResponse
 */
export type GovJobsReportResponseJson = {
  /**
   * @generated from field: required bytes content = 1;
   */
  content?: string;

  /**
   * @generated from field: required string filename = 2;
   */
  filename?: string;
};

/**
 * Describes the message raccoonai.GovJobsReportResponse.
 * Use `create(GovJobsReportResponseSchema)` to create a new message.
 */
export const GovJobsReportResponseSchema: GenMessage<GovJobsReportResponse, {jsonType: GovJobsReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 2);

/**
 * @generated from message raccoonai.GovServiceProviderInfo
 */
export type GovServiceProviderInfo = Message<"raccoonai.GovServiceProviderInfo"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required string bin = 3;
   */
  bin: string;

  /**
   * @generated from field: required uint64 number_of_trucks = 4 [json_name = "number_of_trucks"];
   */
  numberOfTrucks: bigint;

  /**
   * @generated from field: optional uint64 parent_id = 5 [json_name = "parent_id"];
   */
  parentId: bigint;

  /**
   * The parent organization itself, for callers that render the hierarchy.
   *
   * @generated from field: optional raccoonai.Organization parent = 6;
   */
  parent?: Organization;
};

/**
 * @generated from message raccoonai.GovServiceProviderInfo
 */
export type GovServiceProviderInfoJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required string bin = 3;
   */
  bin?: string;

  /**
   * @generated from field: required uint64 number_of_trucks = 4 [json_name = "number_of_trucks"];
   */
  number_of_trucks?: string;

  /**
   * @generated from field: optional uint64 parent_id = 5 [json_name = "parent_id"];
   */
  parent_id?: string;

  /**
   * The parent organization itself, for callers that render the hierarchy.
   *
   * @generated from field: optional raccoonai.Organization parent = 6;
   */
  parent?: OrganizationJson;
};

/**
 * Describes the message raccoonai.GovServiceProviderInfo.
 * Use `create(GovServiceProviderInfoSchema)` to create a new message.
 */
export const GovServiceProviderInfoSchema: GenMessage<GovServiceProviderInfo, {jsonType: GovServiceProviderInfoJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 3);

/**
 * @generated from message raccoonai.GovServiceProviderInfoList
 */
export type GovServiceProviderInfoList = Message<"raccoonai.GovServiceProviderInfoList"> & {
  /**
   * @generated from field: repeated raccoonai.GovServiceProviderInfo organizations = 1;
   */
  organizations: GovServiceProviderInfo[];
};

/**
 * @generated from message raccoonai.GovServiceProviderInfoList
 */
export type GovServiceProviderInfoListJson = {
  /**
   * @generated from field: repeated raccoonai.GovServiceProviderInfo organizations = 1;
   */
  organizations?: GovServiceProviderInfoJson[];
};

/**
 * Describes the message raccoonai.GovServiceProviderInfoList.
 * Use `create(GovServiceProviderInfoListSchema)` to create a new message.
 */
export const GovServiceProviderInfoListSchema: GenMessage<GovServiceProviderInfoList, {jsonType: GovServiceProviderInfoListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 4);

/**
 * @generated from message raccoonai.GovServiceProviderStats
 */
export type GovServiceProviderStats = Message<"raccoonai.GovServiceProviderStats"> & {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * @generated from field: required uint64 affiliated_receivers = 2 [json_name = "affiliated_receivers"];
   */
  affiliatedReceivers: bigint;

  /**
   * @generated from field: required uint64 affiliated_trucks = 3 [json_name = "affiliated_trucks"];
   */
  affiliatedTrucks: bigint;

  /**
   * @generated from field: required uint64 affiliated_pickup_locations = 4 [json_name = "affiliated_pickup_locations"];
   */
  affiliatedPickupLocations: bigint;

  /**
   * @generated from field: required uint64 affiliated_disposal_sites = 5 [json_name = "affiliated_disposal_sites"];
   */
  affiliatedDisposalSites: bigint;

  /**
   * @generated from field: required uint64 affiliated_depots = 6 [json_name = "affiliated_depots"];
   */
  affiliatedDepots: bigint;
};

/**
 * @generated from message raccoonai.GovServiceProviderStats
 */
export type GovServiceProviderStatsJson = {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: OrganizationJson;

  /**
   * @generated from field: required uint64 affiliated_receivers = 2 [json_name = "affiliated_receivers"];
   */
  affiliated_receivers?: string;

  /**
   * @generated from field: required uint64 affiliated_trucks = 3 [json_name = "affiliated_trucks"];
   */
  affiliated_trucks?: string;

  /**
   * @generated from field: required uint64 affiliated_pickup_locations = 4 [json_name = "affiliated_pickup_locations"];
   */
  affiliated_pickup_locations?: string;

  /**
   * @generated from field: required uint64 affiliated_disposal_sites = 5 [json_name = "affiliated_disposal_sites"];
   */
  affiliated_disposal_sites?: string;

  /**
   * @generated from field: required uint64 affiliated_depots = 6 [json_name = "affiliated_depots"];
   */
  affiliated_depots?: string;
};

/**
 * Describes the message raccoonai.GovServiceProviderStats.
 * Use `create(GovServiceProviderStatsSchema)` to create a new message.
 */
export const GovServiceProviderStatsSchema: GenMessage<GovServiceProviderStats, {jsonType: GovServiceProviderStatsJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 5);

/**
 * @generated from message raccoonai.GovServiceReceiverStats
 */
export type GovServiceReceiverStats = Message<"raccoonai.GovServiceReceiverStats"> & {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * @generated from field: repeated raccoonai.Contract contracts = 2;
   */
  contracts: Contract[];

  /**
   * @generated from field: optional uint64 number_of_visits = 3 [json_name = "number_of_visits"];
   */
  numberOfVisits: bigint;
};

/**
 * @generated from message raccoonai.GovServiceReceiverStats
 */
export type GovServiceReceiverStatsJson = {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: OrganizationJson;

  /**
   * @generated from field: repeated raccoonai.Contract contracts = 2;
   */
  contracts?: ContractJson[];

  /**
   * @generated from field: optional uint64 number_of_visits = 3 [json_name = "number_of_visits"];
   */
  number_of_visits?: string;
};

/**
 * Describes the message raccoonai.GovServiceReceiverStats.
 * Use `create(GovServiceReceiverStatsSchema)` to create a new message.
 */
export const GovServiceReceiverStatsSchema: GenMessage<GovServiceReceiverStats, {jsonType: GovServiceReceiverStatsJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 6);

/**
 * @generated from message raccoonai.GovPickupLocationInfo
 */
export type GovPickupLocationInfo = Message<"raccoonai.GovPickupLocationInfo"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required double lat = 3;
   */
  lat: number;

  /**
   * @generated from field: required double lon = 4;
   */
  lon: number;

  /**
   * @generated from field: optional uint64 service_provider_id = 5 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: optional string service_provider_name = 6 [json_name = "service_provider_name"];
   */
  serviceProviderName: string;

  /**
   * The service provider organization itself; service_provider_name stays for
   * callers already reading it.
   *
   * @generated from field: optional raccoonai.Organization service_provider = 7 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;
};

/**
 * @generated from message raccoonai.GovPickupLocationInfo
 */
export type GovPickupLocationInfoJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required double lat = 3;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lon = 4;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 service_provider_id = 5 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: optional string service_provider_name = 6 [json_name = "service_provider_name"];
   */
  service_provider_name?: string;

  /**
   * The service provider organization itself; service_provider_name stays for
   * callers already reading it.
   *
   * @generated from field: optional raccoonai.Organization service_provider = 7 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;
};

/**
 * Describes the message raccoonai.GovPickupLocationInfo.
 * Use `create(GovPickupLocationInfoSchema)` to create a new message.
 */
export const GovPickupLocationInfoSchema: GenMessage<GovPickupLocationInfo, {jsonType: GovPickupLocationInfoJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 7);

/**
 * @generated from message raccoonai.GovPickupLocationList
 */
export type GovPickupLocationList = Message<"raccoonai.GovPickupLocationList"> & {
  /**
   * @generated from field: repeated raccoonai.GovPickupLocationInfo pickup_locations = 1 [json_name = "pickup_locations"];
   */
  pickupLocations: GovPickupLocationInfo[];
};

/**
 * @generated from message raccoonai.GovPickupLocationList
 */
export type GovPickupLocationListJson = {
  /**
   * @generated from field: repeated raccoonai.GovPickupLocationInfo pickup_locations = 1 [json_name = "pickup_locations"];
   */
  pickup_locations?: GovPickupLocationInfoJson[];
};

/**
 * Describes the message raccoonai.GovPickupLocationList.
 * Use `create(GovPickupLocationListSchema)` to create a new message.
 */
export const GovPickupLocationListSchema: GenMessage<GovPickupLocationList, {jsonType: GovPickupLocationListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 8);

/**
 * @generated from message raccoonai.GovPickupLocationListRequest
 */
export type GovPickupLocationListRequest = Message<"raccoonai.GovPickupLocationListRequest"> & {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequest;

  /**
   * Only pickup locations hosting container groups of these container types.
   *
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  containerTypeIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 3;
   */
  statuses: LocationStatus[];
};

/**
 * @generated from message raccoonai.GovPickupLocationListRequest
 */
export type GovPickupLocationListRequestJson = {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequestJson;

  /**
   * Only pickup locations hosting container groups of these container types.
   *
   * @generated from field: repeated uint64 container_type_ids = 2 [json_name = "container_type_ids"];
   */
  container_type_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.LocationStatus statuses = 3;
   */
  statuses?: LocationStatusJson[];
};

/**
 * Describes the message raccoonai.GovPickupLocationListRequest.
 * Use `create(GovPickupLocationListRequestSchema)` to create a new message.
 */
export const GovPickupLocationListRequestSchema: GenMessage<GovPickupLocationListRequest, {jsonType: GovPickupLocationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 9);

/**
 * @generated from message raccoonai.GovPickupLocationStats
 */
export type GovPickupLocationStats = Message<"raccoonai.GovPickupLocationStats"> & {
  /**
   * @generated from field: required raccoonai.PickupLocation pickup_location = 1 [json_name = "pickup_location"];
   */
  pickupLocation?: PickupLocation;

  /**
   * @generated from field: required raccoonai.Organization service_provider = 3 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 4 [json_name = "container_groups"];
   */
  containerGroups: ContainerGroup[];
};

/**
 * @generated from message raccoonai.GovPickupLocationStats
 */
export type GovPickupLocationStatsJson = {
  /**
   * @generated from field: required raccoonai.PickupLocation pickup_location = 1 [json_name = "pickup_location"];
   */
  pickup_location?: PickupLocationJson;

  /**
   * @generated from field: required raccoonai.Organization service_provider = 3 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * @generated from field: repeated raccoonai.ContainerGroup container_groups = 4 [json_name = "container_groups"];
   */
  container_groups?: ContainerGroupJson[];
};

/**
 * Describes the message raccoonai.GovPickupLocationStats.
 * Use `create(GovPickupLocationStatsSchema)` to create a new message.
 */
export const GovPickupLocationStatsSchema: GenMessage<GovPickupLocationStats, {jsonType: GovPickupLocationStatsJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 10);

/**
 * @generated from message raccoonai.GovTruckInfo
 */
export type GovTruckInfo = Message<"raccoonai.GovTruckInfo"> & {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: required raccoonai.Organization service_provider = 2 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * @generated from field: optional double lat = 3;
   */
  lat: number;

  /**
   * @generated from field: optional double lon = 4;
   */
  lon: number;

  /**
   * @generated from field: optional uint32 angle = 5;
   */
  angle: number;

  /**
   * The truck's current shift, or its most recent one if none is open now. Unset
   * for a truck that has never been on shift. Only the shift's own fields are
   * populated - its dates above all, which is what this is here for. Its driver,
   * route and jobs are not, so read driver_id rather than driver.
   *
   * @generated from field: optional raccoonai.DriverOnShift last_driver_on_shift = 6 [json_name = "last_driver_on_shift"];
   */
  lastDriverOnShift?: DriverOnShift;

  /**
   * The truck's depot, from its depot_id. Unset means no depot is assigned -
   * deliberately not inferred from the owner organization, since Depots counts
   * a depot's trucks by depot_id alone and would then disagree.
   *
   * @generated from field: optional raccoonai.Location depot = 7;
   */
  depot?: Location;
};

/**
 * @generated from message raccoonai.GovTruckInfo
 */
export type GovTruckInfoJson = {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: required raccoonai.Organization service_provider = 2 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * @generated from field: optional double lat = 3;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double lon = 4;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint32 angle = 5;
   */
  angle?: number;

  /**
   * The truck's current shift, or its most recent one if none is open now. Unset
   * for a truck that has never been on shift. Only the shift's own fields are
   * populated - its dates above all, which is what this is here for. Its driver,
   * route and jobs are not, so read driver_id rather than driver.
   *
   * @generated from field: optional raccoonai.DriverOnShift last_driver_on_shift = 6 [json_name = "last_driver_on_shift"];
   */
  last_driver_on_shift?: DriverOnShiftJson;

  /**
   * The truck's depot, from its depot_id. Unset means no depot is assigned -
   * deliberately not inferred from the owner organization, since Depots counts
   * a depot's trucks by depot_id alone and would then disagree.
   *
   * @generated from field: optional raccoonai.Location depot = 7;
   */
  depot?: LocationJson;
};

/**
 * Describes the message raccoonai.GovTruckInfo.
 * Use `create(GovTruckInfoSchema)` to create a new message.
 */
export const GovTruckInfoSchema: GenMessage<GovTruckInfo, {jsonType: GovTruckInfoJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 11);

/**
 * @generated from message raccoonai.GovTruckList
 */
export type GovTruckList = Message<"raccoonai.GovTruckList"> & {
  /**
   * @generated from field: repeated raccoonai.GovTruckInfo trucks = 1;
   */
  trucks: GovTruckInfo[];
};

/**
 * @generated from message raccoonai.GovTruckList
 */
export type GovTruckListJson = {
  /**
   * @generated from field: repeated raccoonai.GovTruckInfo trucks = 1;
   */
  trucks?: GovTruckInfoJson[];
};

/**
 * Describes the message raccoonai.GovTruckList.
 * Use `create(GovTruckListSchema)` to create a new message.
 */
export const GovTruckListSchema: GenMessage<GovTruckList, {jsonType: GovTruckListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 12);

/**
 * @generated from message raccoonai.GovTruckStats
 */
export type GovTruckStats = Message<"raccoonai.GovTruckStats"> & {
  /**
   * @generated from field: required raccoonai.GovTruckInfo truck = 1;
   */
  truck?: GovTruckInfo;

  /**
   * @generated from field: optional raccoonai.Location depot = 3;
   */
  depot?: Location;

  /**
   * @generated from field: optional uint64 number_of_gps_stops = 4 [json_name = "number_of_gps_stops"];
   */
  numberOfGpsStops: bigint;

  /**
   * @generated from field: optional uint64 number_of_routes = 5 [json_name = "number_of_routes"];
   */
  numberOfRoutes: bigint;

  /**
   * @generated from field: optional bool is_latest_route_active = 6 [json_name = "is_latest_route_active"];
   */
  isLatestRouteActive: boolean;
};

/**
 * @generated from message raccoonai.GovTruckStats
 */
export type GovTruckStatsJson = {
  /**
   * @generated from field: required raccoonai.GovTruckInfo truck = 1;
   */
  truck?: GovTruckInfoJson;

  /**
   * @generated from field: optional raccoonai.Location depot = 3;
   */
  depot?: LocationJson;

  /**
   * @generated from field: optional uint64 number_of_gps_stops = 4 [json_name = "number_of_gps_stops"];
   */
  number_of_gps_stops?: string;

  /**
   * @generated from field: optional uint64 number_of_routes = 5 [json_name = "number_of_routes"];
   */
  number_of_routes?: string;

  /**
   * @generated from field: optional bool is_latest_route_active = 6 [json_name = "is_latest_route_active"];
   */
  is_latest_route_active?: boolean;
};

/**
 * Describes the message raccoonai.GovTruckStats.
 * Use `create(GovTruckStatsSchema)` to create a new message.
 */
export const GovTruckStatsSchema: GenMessage<GovTruckStats, {jsonType: GovTruckStatsJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 13);

/**
 * @generated from message raccoonai.GovDepotInfo
 */
export type GovDepotInfo = Message<"raccoonai.GovDepotInfo"> & {
  /**
   * @generated from field: required raccoonai.Location depot = 1;
   */
  depot?: Location;

  /**
   * @generated from field: required raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: required uint64 number_of_trucks = 3 [json_name = "number_of_trucks"];
   */
  numberOfTrucks: bigint;
};

/**
 * @generated from message raccoonai.GovDepotInfo
 */
export type GovDepotInfoJson = {
  /**
   * @generated from field: required raccoonai.Location depot = 1;
   */
  depot?: LocationJson;

  /**
   * @generated from field: required raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: required uint64 number_of_trucks = 3 [json_name = "number_of_trucks"];
   */
  number_of_trucks?: string;
};

/**
 * Describes the message raccoonai.GovDepotInfo.
 * Use `create(GovDepotInfoSchema)` to create a new message.
 */
export const GovDepotInfoSchema: GenMessage<GovDepotInfo, {jsonType: GovDepotInfoJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 14);

/**
 * @generated from message raccoonai.GovDepotInfoList
 */
export type GovDepotInfoList = Message<"raccoonai.GovDepotInfoList"> & {
  /**
   * @generated from field: repeated raccoonai.GovDepotInfo depots = 1;
   */
  depots: GovDepotInfo[];
};

/**
 * @generated from message raccoonai.GovDepotInfoList
 */
export type GovDepotInfoListJson = {
  /**
   * @generated from field: repeated raccoonai.GovDepotInfo depots = 1;
   */
  depots?: GovDepotInfoJson[];
};

/**
 * Describes the message raccoonai.GovDepotInfoList.
 * Use `create(GovDepotInfoListSchema)` to create a new message.
 */
export const GovDepotInfoListSchema: GenMessage<GovDepotInfoList, {jsonType: GovDepotInfoListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 15);

/**
 * @generated from message raccoonai.GovServiceProviderAnalyticsRequest
 */
export type GovServiceProviderAnalyticsRequest = Message<"raccoonai.GovServiceProviderAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovServiceProviderAnalyticsRequest
 */
export type GovServiceProviderAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovServiceProviderAnalyticsRequest.
 * Use `create(GovServiceProviderAnalyticsRequestSchema)` to create a new message.
 */
export const GovServiceProviderAnalyticsRequestSchema: GenMessage<GovServiceProviderAnalyticsRequest, {jsonType: GovServiceProviderAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 16);

/**
 * @generated from message raccoonai.GovServiceProviderAnalyticsResponse
 */
export type GovServiceProviderAnalyticsResponse = Message<"raccoonai.GovServiceProviderAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: required uint64 total_locations = 3 [json_name = "total_locations"];
   */
  totalLocations: bigint;

  /**
   * @generated from field: required uint64 trucks_active = 4 [json_name = "trucks_active"];
   */
  trucksActive: bigint;

  /**
   * @generated from field: required uint64 total_trucks = 5 [json_name = "total_trucks"];
   */
  totalTrucks: bigint;
};

/**
 * @generated from message raccoonai.GovServiceProviderAnalyticsResponse
 */
export type GovServiceProviderAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 service_provider_id = 1 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: required uint64 total_locations = 3 [json_name = "total_locations"];
   */
  total_locations?: string;

  /**
   * @generated from field: required uint64 trucks_active = 4 [json_name = "trucks_active"];
   */
  trucks_active?: string;

  /**
   * @generated from field: required uint64 total_trucks = 5 [json_name = "total_trucks"];
   */
  total_trucks?: string;
};

/**
 * Describes the message raccoonai.GovServiceProviderAnalyticsResponse.
 * Use `create(GovServiceProviderAnalyticsResponseSchema)` to create a new message.
 */
export const GovServiceProviderAnalyticsResponseSchema: GenMessage<GovServiceProviderAnalyticsResponse, {jsonType: GovServiceProviderAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 17);

/**
 * @generated from message raccoonai.GovServiceReceiverAnalyticsRequest
 */
export type GovServiceReceiverAnalyticsRequest = Message<"raccoonai.GovServiceReceiverAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 service_receiver_id = 1 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * @generated from field: optional uint64 container_group_id = 3 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;
};

/**
 * @generated from message raccoonai.GovServiceReceiverAnalyticsRequest
 */
export type GovServiceReceiverAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 service_receiver_id = 1 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * @generated from field: optional uint64 container_group_id = 3 [json_name = "container_group_id"];
   */
  container_group_id?: string;
};

/**
 * Describes the message raccoonai.GovServiceReceiverAnalyticsRequest.
 * Use `create(GovServiceReceiverAnalyticsRequestSchema)` to create a new message.
 */
export const GovServiceReceiverAnalyticsRequestSchema: GenMessage<GovServiceReceiverAnalyticsRequest, {jsonType: GovServiceReceiverAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 18);

/**
 * @generated from message raccoonai.GovServiceReceiverAnalyticsResponse
 */
export type GovServiceReceiverAnalyticsResponse = Message<"raccoonai.GovServiceReceiverAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 service_receiver_id = 1 [json_name = "service_receiver_id"];
   */
  serviceReceiverId: bigint;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];
};

/**
 * @generated from message raccoonai.GovServiceReceiverAnalyticsResponse
 */
export type GovServiceReceiverAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 service_receiver_id = 1 [json_name = "service_receiver_id"];
   */
  service_receiver_id?: string;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];
};

/**
 * Describes the message raccoonai.GovServiceReceiverAnalyticsResponse.
 * Use `create(GovServiceReceiverAnalyticsResponseSchema)` to create a new message.
 */
export const GovServiceReceiverAnalyticsResponseSchema: GenMessage<GovServiceReceiverAnalyticsResponse, {jsonType: GovServiceReceiverAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 19);

/**
 * @generated from message raccoonai.GovPickupLocationAnalyticsRequest
 */
export type GovPickupLocationAnalyticsRequest = Message<"raccoonai.GovPickupLocationAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovPickupLocationAnalyticsRequest
 */
export type GovPickupLocationAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovPickupLocationAnalyticsRequest.
 * Use `create(GovPickupLocationAnalyticsRequestSchema)` to create a new message.
 */
export const GovPickupLocationAnalyticsRequestSchema: GenMessage<GovPickupLocationAnalyticsRequest, {jsonType: GovPickupLocationAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 20);

/**
 * @generated from message raccoonai.GovPickupLocationAnalyticsResponse
 */
export type GovPickupLocationAnalyticsResponse = Message<"raccoonai.GovPickupLocationAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];
};

/**
 * @generated from message raccoonai.GovPickupLocationAnalyticsResponse
 */
export type GovPickupLocationAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 pickup_location_id = 1 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];
};

/**
 * Describes the message raccoonai.GovPickupLocationAnalyticsResponse.
 * Use `create(GovPickupLocationAnalyticsResponseSchema)` to create a new message.
 */
export const GovPickupLocationAnalyticsResponseSchema: GenMessage<GovPickupLocationAnalyticsResponse, {jsonType: GovPickupLocationAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 21);

/**
 * @generated from message raccoonai.GovTruckAnalyticsRequest
 */
export type GovTruckAnalyticsRequest = Message<"raccoonai.GovTruckAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovTruckAnalyticsRequest
 */
export type GovTruckAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovTruckAnalyticsRequest.
 * Use `create(GovTruckAnalyticsRequestSchema)` to create a new message.
 */
export const GovTruckAnalyticsRequestSchema: GenMessage<GovTruckAnalyticsRequest, {jsonType: GovTruckAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 22);

/**
 * @generated from message raccoonai.GovTruckAnalyticsResponse
 */
export type GovTruckAnalyticsResponse = Message<"raccoonai.GovTruckAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: required uint64 disposal_stops = 3 [json_name = "disposal_stops"];
   */
  disposalStops: bigint;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 4 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];

  /**
   * @generated from field: optional uint64 anomalies = 5;
   */
  anomalies: bigint;
};

/**
 * @generated from message raccoonai.GovTruckAnalyticsResponse
 */
export type GovTruckAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: required uint64 disposal_stops = 3 [json_name = "disposal_stops"];
   */
  disposal_stops?: string;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 4 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];

  /**
   * @generated from field: optional uint64 anomalies = 5;
   */
  anomalies?: string;
};

/**
 * Describes the message raccoonai.GovTruckAnalyticsResponse.
 * Use `create(GovTruckAnalyticsResponseSchema)` to create a new message.
 */
export const GovTruckAnalyticsResponseSchema: GenMessage<GovTruckAnalyticsResponse, {jsonType: GovTruckAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 23);

/**
 * @generated from message raccoonai.GovTruckTravelPathRequest
 */
export type GovTruckTravelPathRequest = Message<"raccoonai.GovTruckTravelPathRequest"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovTruckTravelPathRequest
 */
export type GovTruckTravelPathRequestJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovTruckTravelPathRequest.
 * Use `create(GovTruckTravelPathRequestSchema)` to create a new message.
 */
export const GovTruckTravelPathRequestSchema: GenMessage<GovTruckTravelPathRequest, {jsonType: GovTruckTravelPathRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 24);

/**
 * @generated from message raccoonai.GovTruckTravelPathResponse
 */
export type GovTruckTravelPathResponse = Message<"raccoonai.GovTruckTravelPathResponse"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required google.protobuf.Struct geojson_feature = 3 [json_name = "geojson_feature"];
   */
  geojsonFeature?: JsonObject;
};

/**
 * @generated from message raccoonai.GovTruckTravelPathResponse
 */
export type GovTruckTravelPathResponseJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required google.protobuf.Struct geojson_feature = 3 [json_name = "geojson_feature"];
   */
  geojson_feature?: StructJson;
};

/**
 * Describes the message raccoonai.GovTruckTravelPathResponse.
 * Use `create(GovTruckTravelPathResponseSchema)` to create a new message.
 */
export const GovTruckTravelPathResponseSchema: GenMessage<GovTruckTravelPathResponse, {jsonType: GovTruckTravelPathResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 25);

/**
 * TruckService.GetTruckGpsStops for a truck in the caller's scope.
 *
 * @generated from message raccoonai.GovTruckGpsStopsRequest
 */
export type GovTruckGpsStopsRequest = Message<"raccoonai.GovTruckGpsStopsRequest"> & {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * @generated from field: optional bool include_unmatched = 3 [json_name = "include_unmatched"];
   */
  includeUnmatched: boolean;
};

/**
 * TruckService.GetTruckGpsStops for a truck in the caller's scope.
 *
 * @generated from message raccoonai.GovTruckGpsStopsRequest
 */
export type GovTruckGpsStopsRequestJson = {
  /**
   * @generated from field: required uint64 truck_id = 1 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * @generated from field: optional bool include_unmatched = 3 [json_name = "include_unmatched"];
   */
  include_unmatched?: boolean;
};

/**
 * Describes the message raccoonai.GovTruckGpsStopsRequest.
 * Use `create(GovTruckGpsStopsRequestSchema)` to create a new message.
 */
export const GovTruckGpsStopsRequestSchema: GenMessage<GovTruckGpsStopsRequest, {jsonType: GovTruckGpsStopsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 26);

/**
 * @generated from message raccoonai.GovDepotAnalyticsRequest
 */
export type GovDepotAnalyticsRequest = Message<"raccoonai.GovDepotAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 depot_id = 1 [json_name = "depot_id"];
   */
  depotId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovDepotAnalyticsRequest
 */
export type GovDepotAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 depot_id = 1 [json_name = "depot_id"];
   */
  depot_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovDepotAnalyticsRequest.
 * Use `create(GovDepotAnalyticsRequestSchema)` to create a new message.
 */
export const GovDepotAnalyticsRequestSchema: GenMessage<GovDepotAnalyticsRequest, {jsonType: GovDepotAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 27);

/**
 * @generated from message raccoonai.GovTruckActiveResponse
 */
export type GovTruckActiveResponse = Message<"raccoonai.GovTruckActiveResponse"> & {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_active = 2 [json_name = "last_active"];
   */
  lastActive?: Timestamp;
};

/**
 * @generated from message raccoonai.GovTruckActiveResponse
 */
export type GovTruckActiveResponseJson = {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_active = 2 [json_name = "last_active"];
   */
  last_active?: TimestampJson;
};

/**
 * Describes the message raccoonai.GovTruckActiveResponse.
 * Use `create(GovTruckActiveResponseSchema)` to create a new message.
 */
export const GovTruckActiveResponseSchema: GenMessage<GovTruckActiveResponse, {jsonType: GovTruckActiveResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 28);

/**
 * @generated from message raccoonai.GovDepotAnalyticsResponse
 */
export type GovDepotAnalyticsResponse = Message<"raccoonai.GovDepotAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 depot_id = 1 [json_name = "depot_id"];
   */
  depotId: bigint;

  /**
   * @generated from field: required uint64 total_trucks = 2 [json_name = "total_trucks"];
   */
  totalTrucks: bigint;

  /**
   * @generated from field: required uint64 trucks_active = 3 [json_name = "trucks_active"];
   */
  trucksActive: bigint;

  /**
   * @generated from field: repeated raccoonai.GovTruckActiveResponse truck_actities = 4 [json_name = "trucks"];
   */
  truckActities: GovTruckActiveResponse[];
};

/**
 * @generated from message raccoonai.GovDepotAnalyticsResponse
 */
export type GovDepotAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 depot_id = 1 [json_name = "depot_id"];
   */
  depot_id?: string;

  /**
   * @generated from field: required uint64 total_trucks = 2 [json_name = "total_trucks"];
   */
  total_trucks?: string;

  /**
   * @generated from field: required uint64 trucks_active = 3 [json_name = "trucks_active"];
   */
  trucks_active?: string;

  /**
   * @generated from field: repeated raccoonai.GovTruckActiveResponse truck_actities = 4 [json_name = "trucks"];
   */
  trucks?: GovTruckActiveResponseJson[];
};

/**
 * Describes the message raccoonai.GovDepotAnalyticsResponse.
 * Use `create(GovDepotAnalyticsResponseSchema)` to create a new message.
 */
export const GovDepotAnalyticsResponseSchema: GenMessage<GovDepotAnalyticsResponse, {jsonType: GovDepotAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 29);

/**
 * @generated from message raccoonai.GovSuspiciousLocationAnalyticsRequest
 */
export type GovSuspiciousLocationAnalyticsRequest = Message<"raccoonai.GovSuspiciousLocationAnalyticsRequest"> & {
  /**
   * @generated from field: required uint64 suspicious_location_id = 1 [json_name = "suspicious_location_id"];
   */
  suspiciousLocationId: bigint;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovSuspiciousLocationAnalyticsRequest
 */
export type GovSuspiciousLocationAnalyticsRequestJson = {
  /**
   * @generated from field: required uint64 suspicious_location_id = 1 [json_name = "suspicious_location_id"];
   */
  suspicious_location_id?: string;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovSuspiciousLocationAnalyticsRequest.
 * Use `create(GovSuspiciousLocationAnalyticsRequestSchema)` to create a new message.
 */
export const GovSuspiciousLocationAnalyticsRequestSchema: GenMessage<GovSuspiciousLocationAnalyticsRequest, {jsonType: GovSuspiciousLocationAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 30);

/**
 * @generated from message raccoonai.GovSuspiciousLocationAnalyticsResponse
 */
export type GovSuspiciousLocationAnalyticsResponse = Message<"raccoonai.GovSuspiciousLocationAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 suspicious_location_id = 1 [json_name = "suspicious_location_id"];
   */
  suspiciousLocationId: bigint;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];

  /**
   * @generated from field: optional uint64 anomalies = 4;
   */
  anomalies: bigint;
};

/**
 * @generated from message raccoonai.GovSuspiciousLocationAnalyticsResponse
 */
export type GovSuspiciousLocationAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 suspicious_location_id = 1 [json_name = "suspicious_location_id"];
   */
  suspicious_location_id?: string;

  /**
   * @generated from field: required uint64 total_location_stops = 2 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];

  /**
   * @generated from field: optional uint64 anomalies = 4;
   */
  anomalies?: string;
};

/**
 * Describes the message raccoonai.GovSuspiciousLocationAnalyticsResponse.
 * Use `create(GovSuspiciousLocationAnalyticsResponseSchema)` to create a new message.
 */
export const GovSuspiciousLocationAnalyticsResponseSchema: GenMessage<GovSuspiciousLocationAnalyticsResponse, {jsonType: GovSuspiciousLocationAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 31);

/**
 * @generated from message raccoonai.GovDashboardAnalyticsRequest
 */
export type GovDashboardAnalyticsRequest = Message<"raccoonai.GovDashboardAnalyticsRequest"> & {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequest;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;
};

/**
 * @generated from message raccoonai.GovDashboardAnalyticsRequest
 */
export type GovDashboardAnalyticsRequestJson = {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequestJson;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;
};

/**
 * Describes the message raccoonai.GovDashboardAnalyticsRequest.
 * Use `create(GovDashboardAnalyticsRequestSchema)` to create a new message.
 */
export const GovDashboardAnalyticsRequestSchema: GenMessage<GovDashboardAnalyticsRequest, {jsonType: GovDashboardAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 32);

/**
 * @generated from message raccoonai.GovDashboardAnalyticsResponse
 */
export type GovDashboardAnalyticsResponse = Message<"raccoonai.GovDashboardAnalyticsResponse"> & {
  /**
   * @generated from field: required uint64 total_location_stops = 1 [json_name = "total_location_stops"];
   */
  totalLocationStops: bigint;

  /**
   * @generated from field: required uint64 total_locations = 2 [json_name = "total_locations"];
   */
  totalLocations: bigint;

  /**
   * @generated from field: required uint64 unique_location_stops = 3 [json_name = "unique_location_stops"];
   */
  uniqueLocationStops: bigint;

  /**
   * @generated from field: required uint64 trucks_active = 4 [json_name = "trucks_active"];
   */
  trucksActive: bigint;

  /**
   * @generated from field: required uint64 total_trucks = 5 [json_name = "total_trucks"];
   */
  totalTrucks: bigint;

  /**
   * @generated from field: required uint64 total_anomalies = 6 [json_name = "total_anomalies"];
   */
  totalAnomalies: bigint;

  /**
   * @generated from field: required uint64 service_providers_with_anomalies = 7 [json_name = "service_providers_with_anomalies"];
   */
  serviceProvidersWithAnomalies: bigint;
};

/**
 * @generated from message raccoonai.GovDashboardAnalyticsResponse
 */
export type GovDashboardAnalyticsResponseJson = {
  /**
   * @generated from field: required uint64 total_location_stops = 1 [json_name = "total_location_stops"];
   */
  total_location_stops?: string;

  /**
   * @generated from field: required uint64 total_locations = 2 [json_name = "total_locations"];
   */
  total_locations?: string;

  /**
   * @generated from field: required uint64 unique_location_stops = 3 [json_name = "unique_location_stops"];
   */
  unique_location_stops?: string;

  /**
   * @generated from field: required uint64 trucks_active = 4 [json_name = "trucks_active"];
   */
  trucks_active?: string;

  /**
   * @generated from field: required uint64 total_trucks = 5 [json_name = "total_trucks"];
   */
  total_trucks?: string;

  /**
   * @generated from field: required uint64 total_anomalies = 6 [json_name = "total_anomalies"];
   */
  total_anomalies?: string;

  /**
   * @generated from field: required uint64 service_providers_with_anomalies = 7 [json_name = "service_providers_with_anomalies"];
   */
  service_providers_with_anomalies?: string;
};

/**
 * Describes the message raccoonai.GovDashboardAnalyticsResponse.
 * Use `create(GovDashboardAnalyticsResponseSchema)` to create a new message.
 */
export const GovDashboardAnalyticsResponseSchema: GenMessage<GovDashboardAnalyticsResponse, {jsonType: GovDashboardAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 33);

/**
 * @generated from message raccoonai.SuspiciousLocation
 */
export type SuspiciousLocation = Message<"raccoonai.SuspiciousLocation"> & {
  /**
   * @generated from field: required raccoonai.Location location = 1;
   */
  location?: Location;

  /**
   * @generated from field: required uint64 total_stops = 2 [json_name = "total_stops"];
   */
  totalStops: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 3 [json_name = "archived_at"];
   */
  archivedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.SuspiciousLocation
 */
export type SuspiciousLocationJson = {
  /**
   * @generated from field: required raccoonai.Location location = 1;
   */
  location?: LocationJson;

  /**
   * @generated from field: required uint64 total_stops = 2 [json_name = "total_stops"];
   */
  total_stops?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 3 [json_name = "archived_at"];
   */
  archived_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.SuspiciousLocation.
 * Use `create(SuspiciousLocationSchema)` to create a new message.
 */
export const SuspiciousLocationSchema: GenMessage<SuspiciousLocation, {jsonType: SuspiciousLocationJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 34);

/**
 * @generated from message raccoonai.SuspiciousLocationResponse
 */
export type SuspiciousLocationResponse = Message<"raccoonai.SuspiciousLocationResponse"> & {
  /**
   * @generated from field: repeated raccoonai.SuspiciousLocation locations = 1;
   */
  locations: SuspiciousLocation[];
};

/**
 * @generated from message raccoonai.SuspiciousLocationResponse
 */
export type SuspiciousLocationResponseJson = {
  /**
   * @generated from field: repeated raccoonai.SuspiciousLocation locations = 1;
   */
  locations?: SuspiciousLocationJson[];
};

/**
 * Describes the message raccoonai.SuspiciousLocationResponse.
 * Use `create(SuspiciousLocationResponseSchema)` to create a new message.
 */
export const SuspiciousLocationResponseSchema: GenMessage<SuspiciousLocationResponse, {jsonType: SuspiciousLocationResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 35);

/**
 * @generated from message raccoonai.AnomalieRouteResponse
 */
export type AnomalieRouteResponse = Message<"raccoonai.AnomalieRouteResponse"> & {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: required raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];
};

/**
 * @generated from message raccoonai.AnomalieRouteResponse
 */
export type AnomalieRouteResponseJson = {
  /**
   * @generated from field: required raccoonai.Truck truck = 1;
   */
  truck?: TruckJson;

  /**
   * @generated from field: required raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 3 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];
};

/**
 * Describes the message raccoonai.AnomalieRouteResponse.
 * Use `create(AnomalieRouteResponseSchema)` to create a new message.
 */
export const AnomalieRouteResponseSchema: GenMessage<AnomalieRouteResponse, {jsonType: AnomalieRouteResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 36);

/**
 * @generated from message raccoonai.GovRawScaleAnalyticsRequest
 */
export type GovRawScaleAnalyticsRequest = Message<"raccoonai.GovRawScaleAnalyticsRequest"> & {
  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 1 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.GovRawScaleAnalyticsRequest
 */
export type GovRawScaleAnalyticsRequestJson = {
  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 1 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.GovRawScaleAnalyticsRequest.
 * Use `create(GovRawScaleAnalyticsRequestSchema)` to create a new message.
 */
export const GovRawScaleAnalyticsRequestSchema: GenMessage<GovRawScaleAnalyticsRequest, {jsonType: GovRawScaleAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 37);

/**
 * @generated from message raccoonai.GovRawScaleAnalyticsResponse
 */
export type GovRawScaleAnalyticsResponse = Message<"raccoonai.GovRawScaleAnalyticsResponse"> & {
  /**
   * @generated from field: required double total_netto_kg = 1 [json_name = "total_netto_kg"];
   */
  totalNettoKg: number;

  /**
   * @generated from field: required uint64 total_records = 2 [json_name = "total_records"];
   */
  totalRecords: bigint;

  /**
   * @generated from field: map<string, double> weights_by_waste_type = 3 [json_name = "weights_by_waste_type"];
   */
  weightsByWasteType: { [key: string]: number };
};

/**
 * @generated from message raccoonai.GovRawScaleAnalyticsResponse
 */
export type GovRawScaleAnalyticsResponseJson = {
  /**
   * @generated from field: required double total_netto_kg = 1 [json_name = "total_netto_kg"];
   */
  total_netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required uint64 total_records = 2 [json_name = "total_records"];
   */
  total_records?: string;

  /**
   * @generated from field: map<string, double> weights_by_waste_type = 3 [json_name = "weights_by_waste_type"];
   */
  weights_by_waste_type?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };
};

/**
 * Describes the message raccoonai.GovRawScaleAnalyticsResponse.
 * Use `create(GovRawScaleAnalyticsResponseSchema)` to create a new message.
 */
export const GovRawScaleAnalyticsResponseSchema: GenMessage<GovRawScaleAnalyticsResponse, {jsonType: GovRawScaleAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 38);

/**
 * @generated from message raccoonai.GovRawScaleRecordListRequest
 */
export type GovRawScaleRecordListRequest = Message<"raccoonai.GovRawScaleRecordListRequest"> & {
  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 1 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.GovRawScaleRecordListRequest
 */
export type GovRawScaleRecordListRequestJson = {
  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 1 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.GovRawScaleRecordListRequest.
 * Use `create(GovRawScaleRecordListRequestSchema)` to create a new message.
 */
export const GovRawScaleRecordListRequestSchema: GenMessage<GovRawScaleRecordListRequest, {jsonType: GovRawScaleRecordListRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 39);

/**
 * @generated from message raccoonai.GovRawScaleRecordByCompany
 */
export type GovRawScaleRecordByCompany = Message<"raccoonai.GovRawScaleRecordByCompany"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required double total_netto_kg = 2 [json_name = "total_netto_kg"];
   */
  totalNettoKg: number;

  /**
   * @generated from field: required uint64 total_records = 3 [json_name = "total_records"];
   */
  totalRecords: bigint;

  /**
   * @generated from field: map<string, double> weights_by_waste_type = 4 [json_name = "weights_by_waste_type"];
   */
  weightsByWasteType: { [key: string]: number };

  /**
   * @generated from field: optional string organization_name = 5 [json_name = "organization_name"];
   */
  organizationName: string;
};

/**
 * @generated from message raccoonai.GovRawScaleRecordByCompany
 */
export type GovRawScaleRecordByCompanyJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required double total_netto_kg = 2 [json_name = "total_netto_kg"];
   */
  total_netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required uint64 total_records = 3 [json_name = "total_records"];
   */
  total_records?: string;

  /**
   * @generated from field: map<string, double> weights_by_waste_type = 4 [json_name = "weights_by_waste_type"];
   */
  weights_by_waste_type?: { [key: string]: number | "NaN" | "Infinity" | "-Infinity" };

  /**
   * @generated from field: optional string organization_name = 5 [json_name = "organization_name"];
   */
  organization_name?: string;
};

/**
 * Describes the message raccoonai.GovRawScaleRecordByCompany.
 * Use `create(GovRawScaleRecordByCompanySchema)` to create a new message.
 */
export const GovRawScaleRecordByCompanySchema: GenMessage<GovRawScaleRecordByCompany, {jsonType: GovRawScaleRecordByCompanyJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 40);

/**
 * @generated from message raccoonai.GovRawScaleRecordByCompanyResponse
 */
export type GovRawScaleRecordByCompanyResponse = Message<"raccoonai.GovRawScaleRecordByCompanyResponse"> & {
  /**
   * @generated from field: repeated raccoonai.GovRawScaleRecordByCompany records = 1;
   */
  records: GovRawScaleRecordByCompany[];
};

/**
 * @generated from message raccoonai.GovRawScaleRecordByCompanyResponse
 */
export type GovRawScaleRecordByCompanyResponseJson = {
  /**
   * @generated from field: repeated raccoonai.GovRawScaleRecordByCompany records = 1;
   */
  records?: GovRawScaleRecordByCompanyJson[];
};

/**
 * Describes the message raccoonai.GovRawScaleRecordByCompanyResponse.
 * Use `create(GovRawScaleRecordByCompanyResponseSchema)` to create a new message.
 */
export const GovRawScaleRecordByCompanyResponseSchema: GenMessage<GovRawScaleRecordByCompanyResponse, {jsonType: GovRawScaleRecordByCompanyResponseJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 41);

/**
 * @generated from message raccoonai.GovAnalyticsDisposalSiteVisit
 */
export type GovAnalyticsDisposalSiteVisit = Message<"raccoonai.GovAnalyticsDisposalSiteVisit"> & {
  /**
   * @generated from field: required uint64 disposal_site_id = 1 [json_name = "disposal_site_id"];
   */
  disposalSiteId: bigint;

  /**
   * @generated from field: required uint64 total_visits = 2 [json_name = "total_visits"];
   */
  totalVisits: bigint;

  /**
   * @generated from field: required string disposal_site_name = 3 [json_name = "disposal_site_name"];
   */
  disposalSiteName: string;
};

/**
 * @generated from message raccoonai.GovAnalyticsDisposalSiteVisit
 */
export type GovAnalyticsDisposalSiteVisitJson = {
  /**
   * @generated from field: required uint64 disposal_site_id = 1 [json_name = "disposal_site_id"];
   */
  disposal_site_id?: string;

  /**
   * @generated from field: required uint64 total_visits = 2 [json_name = "total_visits"];
   */
  total_visits?: string;

  /**
   * @generated from field: required string disposal_site_name = 3 [json_name = "disposal_site_name"];
   */
  disposal_site_name?: string;
};

/**
 * Describes the message raccoonai.GovAnalyticsDisposalSiteVisit.
 * Use `create(GovAnalyticsDisposalSiteVisitSchema)` to create a new message.
 */
export const GovAnalyticsDisposalSiteVisitSchema: GenMessage<GovAnalyticsDisposalSiteVisit, {jsonType: GovAnalyticsDisposalSiteVisitJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 42);

/**
 * @generated from message raccoonai.GovAnalyticsDisposalVisitPerProvider
 */
export type GovAnalyticsDisposalVisitPerProvider = Message<"raccoonai.GovAnalyticsDisposalVisitPerProvider"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organizationName: string;

  /**
   * @generated from field: repeated raccoonai.GovAnalyticsDisposalSiteVisit disposal_visits = 3 [json_name = "disposal_visits"];
   */
  disposalVisits: GovAnalyticsDisposalSiteVisit[];

  /**
   * @generated from field: optional uint64 suspicious_count = 4 [json_name = "suspicious_location"];
   */
  suspiciousCount: bigint;
};

/**
 * @generated from message raccoonai.GovAnalyticsDisposalVisitPerProvider
 */
export type GovAnalyticsDisposalVisitPerProviderJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organization_name?: string;

  /**
   * @generated from field: repeated raccoonai.GovAnalyticsDisposalSiteVisit disposal_visits = 3 [json_name = "disposal_visits"];
   */
  disposal_visits?: GovAnalyticsDisposalSiteVisitJson[];

  /**
   * @generated from field: optional uint64 suspicious_count = 4 [json_name = "suspicious_location"];
   */
  suspicious_location?: string;
};

/**
 * Describes the message raccoonai.GovAnalyticsDisposalVisitPerProvider.
 * Use `create(GovAnalyticsDisposalVisitPerProviderSchema)` to create a new message.
 */
export const GovAnalyticsDisposalVisitPerProviderSchema: GenMessage<GovAnalyticsDisposalVisitPerProvider, {jsonType: GovAnalyticsDisposalVisitPerProviderJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 43);

/**
 * @generated from message raccoonai.GovAnalyticsDisposalVisitsForAll
 */
export type GovAnalyticsDisposalVisitsForAll = Message<"raccoonai.GovAnalyticsDisposalVisitsForAll"> & {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsDisposalVisitPerProvider disposal_visit_per_provider = 1 [json_name = "disposal_visit_per_provider"];
   */
  disposalVisitPerProvider: GovAnalyticsDisposalVisitPerProvider[];
};

/**
 * @generated from message raccoonai.GovAnalyticsDisposalVisitsForAll
 */
export type GovAnalyticsDisposalVisitsForAllJson = {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsDisposalVisitPerProvider disposal_visit_per_provider = 1 [json_name = "disposal_visit_per_provider"];
   */
  disposal_visit_per_provider?: GovAnalyticsDisposalVisitPerProviderJson[];
};

/**
 * Describes the message raccoonai.GovAnalyticsDisposalVisitsForAll.
 * Use `create(GovAnalyticsDisposalVisitsForAllSchema)` to create a new message.
 */
export const GovAnalyticsDisposalVisitsForAllSchema: GenMessage<GovAnalyticsDisposalVisitsForAll, {jsonType: GovAnalyticsDisposalVisitsForAllJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 44);

/**
 * @generated from message raccoonai.GovAnalyticsLocationVisitsPerProvider
 */
export type GovAnalyticsLocationVisitsPerProvider = Message<"raccoonai.GovAnalyticsLocationVisitsPerProvider"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organizationName: string;

  /**
   * @generated from field: required uint64 visit_planned = 3 [json_name = "planned_visits"];
   */
  visitPlanned: bigint;

  /**
   * @generated from field: required uint64 visit_fact = 4 [json_name = "visit_fact"];
   */
  visitFact: bigint;

  /**
   * @generated from field: required uint64 visit_confirmed_fail = 5 [json_name = "visit_confirmed_fail"];
   */
  visitConfirmedFail: bigint;
};

/**
 * @generated from message raccoonai.GovAnalyticsLocationVisitsPerProvider
 */
export type GovAnalyticsLocationVisitsPerProviderJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organization_name?: string;

  /**
   * @generated from field: required uint64 visit_planned = 3 [json_name = "planned_visits"];
   */
  planned_visits?: string;

  /**
   * @generated from field: required uint64 visit_fact = 4 [json_name = "visit_fact"];
   */
  visit_fact?: string;

  /**
   * @generated from field: required uint64 visit_confirmed_fail = 5 [json_name = "visit_confirmed_fail"];
   */
  visit_confirmed_fail?: string;
};

/**
 * Describes the message raccoonai.GovAnalyticsLocationVisitsPerProvider.
 * Use `create(GovAnalyticsLocationVisitsPerProviderSchema)` to create a new message.
 */
export const GovAnalyticsLocationVisitsPerProviderSchema: GenMessage<GovAnalyticsLocationVisitsPerProvider, {jsonType: GovAnalyticsLocationVisitsPerProviderJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 45);

/**
 * @generated from message raccoonai.GovAnalyticsLocationVisitsForAll
 */
export type GovAnalyticsLocationVisitsForAll = Message<"raccoonai.GovAnalyticsLocationVisitsForAll"> & {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsLocationVisitsPerProvider location_visit_per_provider = 1 [json_name = "location_visit_per_provider"];
   */
  locationVisitPerProvider: GovAnalyticsLocationVisitsPerProvider[];
};

/**
 * @generated from message raccoonai.GovAnalyticsLocationVisitsForAll
 */
export type GovAnalyticsLocationVisitsForAllJson = {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsLocationVisitsPerProvider location_visit_per_provider = 1 [json_name = "location_visit_per_provider"];
   */
  location_visit_per_provider?: GovAnalyticsLocationVisitsPerProviderJson[];
};

/**
 * Describes the message raccoonai.GovAnalyticsLocationVisitsForAll.
 * Use `create(GovAnalyticsLocationVisitsForAllSchema)` to create a new message.
 */
export const GovAnalyticsLocationVisitsForAllSchema: GenMessage<GovAnalyticsLocationVisitsForAll, {jsonType: GovAnalyticsLocationVisitsForAllJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 46);

/**
 * @generated from message raccoonai.GovAnalyticsAnomalyPerProvider
 */
export type GovAnalyticsAnomalyPerProvider = Message<"raccoonai.GovAnalyticsAnomalyPerProvider"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organizationName: string;

  /**
   * @generated from field: required uint64 daily_disposal_fail = 3 [json_name = "daily_disposal_fail"];
   */
  dailyDisposalFail: bigint;

  /**
   * @generated from field: required uint64 anomaly_stop = 4 [json_name = "anomaly_stop"];
   */
  anomalyStop: bigint;
};

/**
 * @generated from message raccoonai.GovAnalyticsAnomalyPerProvider
 */
export type GovAnalyticsAnomalyPerProviderJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organization_name?: string;

  /**
   * @generated from field: required uint64 daily_disposal_fail = 3 [json_name = "daily_disposal_fail"];
   */
  daily_disposal_fail?: string;

  /**
   * @generated from field: required uint64 anomaly_stop = 4 [json_name = "anomaly_stop"];
   */
  anomaly_stop?: string;
};

/**
 * Describes the message raccoonai.GovAnalyticsAnomalyPerProvider.
 * Use `create(GovAnalyticsAnomalyPerProviderSchema)` to create a new message.
 */
export const GovAnalyticsAnomalyPerProviderSchema: GenMessage<GovAnalyticsAnomalyPerProvider, {jsonType: GovAnalyticsAnomalyPerProviderJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 47);

/**
 * @generated from message raccoonai.GovAnalyticsAnomaliesForAll
 */
export type GovAnalyticsAnomaliesForAll = Message<"raccoonai.GovAnalyticsAnomaliesForAll"> & {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsAnomalyPerProvider anomaly_per_provider = 1 [json_name = "anomaly_per_provider"];
   */
  anomalyPerProvider: GovAnalyticsAnomalyPerProvider[];
};

/**
 * @generated from message raccoonai.GovAnalyticsAnomaliesForAll
 */
export type GovAnalyticsAnomaliesForAllJson = {
  /**
   * @generated from field: repeated raccoonai.GovAnalyticsAnomalyPerProvider anomaly_per_provider = 1 [json_name = "anomaly_per_provider"];
   */
  anomaly_per_provider?: GovAnalyticsAnomalyPerProviderJson[];
};

/**
 * Describes the message raccoonai.GovAnalyticsAnomaliesForAll.
 * Use `create(GovAnalyticsAnomaliesForAllSchema)` to create a new message.
 */
export const GovAnalyticsAnomaliesForAllSchema: GenMessage<GovAnalyticsAnomaliesForAll, {jsonType: GovAnalyticsAnomaliesForAllJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 48);

/**
 * GovDisposalVisit is one truck's visit count at one disposal site in the requested window.
 * has_scale_data says where that count comes from and therefore what it means: true - each
 * visit is a weighbridge record at the site's owner organization; false - each visit is a
 * GPS-detected stop at the site, counted only because the site produced no weighbridge
 * records at all in the window.
 *
 * @generated from message raccoonai.GovDisposalVisit
 */
export type GovDisposalVisit = Message<"raccoonai.GovDisposalVisit"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organizationName: string;

  /**
   * @generated from field: required uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required string plate_number = 4 [json_name = "plate_number"];
   */
  plateNumber: string;

  /**
   * @generated from field: required uint64 disposal_site_id = 5 [json_name = "disposal_site_id"];
   */
  disposalSiteId: bigint;

  /**
   * @generated from field: required string disposal_site_name = 6 [json_name = "disposal_site_name"];
   */
  disposalSiteName: string;

  /**
   * @generated from field: required uint64 total_visits = 7 [json_name = "total_visits"];
   */
  totalVisits: bigint;

  /**
   * @generated from field: required bool has_scale_data = 8 [json_name = "has_scale_data"];
   */
  hasScaleData: boolean;

  /**
   * Total net weight in kilograms across the same weighbridge records total_visits counts.
   * Set only when has_scale_data is true. A record whose net weight was never recorded
   * contributes 0, so this can undercount the tonnage total_visits implies.
   *
   * @generated from field: optional double total_netto_kg = 9 [json_name = "total_netto_kg"];
   */
  totalNettoKg: number;
};

/**
 * GovDisposalVisit is one truck's visit count at one disposal site in the requested window.
 * has_scale_data says where that count comes from and therefore what it means: true - each
 * visit is a weighbridge record at the site's owner organization; false - each visit is a
 * GPS-detected stop at the site, counted only because the site produced no weighbridge
 * records at all in the window.
 *
 * @generated from message raccoonai.GovDisposalVisit
 */
export type GovDisposalVisitJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required string organization_name = 2 [json_name = "organization_name"];
   */
  organization_name?: string;

  /**
   * @generated from field: required uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required string plate_number = 4 [json_name = "plate_number"];
   */
  plate_number?: string;

  /**
   * @generated from field: required uint64 disposal_site_id = 5 [json_name = "disposal_site_id"];
   */
  disposal_site_id?: string;

  /**
   * @generated from field: required string disposal_site_name = 6 [json_name = "disposal_site_name"];
   */
  disposal_site_name?: string;

  /**
   * @generated from field: required uint64 total_visits = 7 [json_name = "total_visits"];
   */
  total_visits?: string;

  /**
   * @generated from field: required bool has_scale_data = 8 [json_name = "has_scale_data"];
   */
  has_scale_data?: boolean;

  /**
   * Total net weight in kilograms across the same weighbridge records total_visits counts.
   * Set only when has_scale_data is true. A record whose net weight was never recorded
   * contributes 0, so this can undercount the tonnage total_visits implies.
   *
   * @generated from field: optional double total_netto_kg = 9 [json_name = "total_netto_kg"];
   */
  total_netto_kg?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.GovDisposalVisit.
 * Use `create(GovDisposalVisitSchema)` to create a new message.
 */
export const GovDisposalVisitSchema: GenMessage<GovDisposalVisit, {jsonType: GovDisposalVisitJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 49);

/**
 * GovDashboardAnalyticsRequest plus the grouping switch, so an existing {filter, from_to}
 * body keeps working unchanged.
 *
 * @generated from message raccoonai.GovDailySummaryRequest
 */
export type GovDailySummaryRequest = Message<"raccoonai.GovDailySummaryRequest"> & {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequest;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  fromTo?: DateTimeFilter;

  /**
   * When true, branches still roll up into their parent organization, but per district
   * instead of city-wide, and every row carries the district it was grouped under. Default
   * false keeps one row per (parent organization, date), with no district fields.
   *
   * @generated from field: optional bool group_by_district = 3 [json_name = "group_by_district"];
   */
  groupByDistrict: boolean;
};

/**
 * GovDashboardAnalyticsRequest plus the grouping switch, so an existing {filter, from_to}
 * body keeps working unchanged.
 *
 * @generated from message raccoonai.GovDailySummaryRequest
 */
export type GovDailySummaryRequestJson = {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequestJson;

  /**
   * @generated from field: required raccoonai.DateTimeFilter from_to = 2 [json_name = "from_to"];
   */
  from_to?: DateTimeFilterJson;

  /**
   * When true, branches still roll up into their parent organization, but per district
   * instead of city-wide, and every row carries the district it was grouped under. Default
   * false keeps one row per (parent organization, date), with no district fields.
   *
   * @generated from field: optional bool group_by_district = 3 [json_name = "group_by_district"];
   */
  group_by_district?: boolean;
};

/**
 * Describes the message raccoonai.GovDailySummaryRequest.
 * Use `create(GovDailySummaryRequestSchema)` to create a new message.
 */
export const GovDailySummaryRequestSchema: GenMessage<GovDailySummaryRequest, {jsonType: GovDailySummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 50);

/**
 * @generated from message raccoonai.GovDailySummaryList
 */
export type GovDailySummaryList = Message<"raccoonai.GovDailySummaryList"> & {
  /**
   * @generated from field: repeated raccoonai.DailySummary daily_summaries = 1 [json_name = "daily_summaries"];
   */
  dailySummaries: DailySummary[];
};

/**
 * @generated from message raccoonai.GovDailySummaryList
 */
export type GovDailySummaryListJson = {
  /**
   * @generated from field: repeated raccoonai.DailySummary daily_summaries = 1 [json_name = "daily_summaries"];
   */
  daily_summaries?: DailySummaryJson[];
};

/**
 * Describes the message raccoonai.GovDailySummaryList.
 * Use `create(GovDailySummaryListSchema)` to create a new message.
 */
export const GovDailySummaryListSchema: GenMessage<GovDailySummaryList, {jsonType: GovDailySummaryListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 51);

/**
 * @generated from message raccoonai.GovDisposalVisitList
 */
export type GovDisposalVisitList = Message<"raccoonai.GovDisposalVisitList"> & {
  /**
   * @generated from field: repeated raccoonai.GovDisposalVisit visits = 1;
   */
  visits: GovDisposalVisit[];
};

/**
 * @generated from message raccoonai.GovDisposalVisitList
 */
export type GovDisposalVisitListJson = {
  /**
   * @generated from field: repeated raccoonai.GovDisposalVisit visits = 1;
   */
  visits?: GovDisposalVisitJson[];
};

/**
 * Describes the message raccoonai.GovDisposalVisitList.
 * Use `create(GovDisposalVisitListSchema)` to create a new message.
 */
export const GovDisposalVisitListSchema: GenMessage<GovDisposalVisitList, {jsonType: GovDisposalVisitListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 52);

/**
 * One row of the AI verification review queue: the verdicts, plus the job they
 * were made about and that job's route.
 *
 * @generated from message raccoonai.GovAiVerificationRow
 */
export type GovAiVerificationRow = Message<"raccoonai.GovAiVerificationRow"> & {
  /**
   * @generated from field: required raccoonai.AiVerification ai_verification = 1 [json_name = "ai_verification"];
   */
  aiVerification?: AiVerification;

  /**
   * The verified job. Unset if the job could not be served; its own
   * ai_verification field is always unset, being a repeat of the verdicts above.
   *
   * @generated from field: optional raccoonai.Job job = 2;
   */
  job?: Job;

  /**
   * The route the job was served on, when ai_verification.route_id is set. Its
   * jobs list is not populated.
   *
   * @generated from field: optional raccoonai.Route route = 3;
   */
  route?: Route;
};

/**
 * One row of the AI verification review queue: the verdicts, plus the job they
 * were made about and that job's route.
 *
 * @generated from message raccoonai.GovAiVerificationRow
 */
export type GovAiVerificationRowJson = {
  /**
   * @generated from field: required raccoonai.AiVerification ai_verification = 1 [json_name = "ai_verification"];
   */
  ai_verification?: AiVerificationJson;

  /**
   * The verified job. Unset if the job could not be served; its own
   * ai_verification field is always unset, being a repeat of the verdicts above.
   *
   * @generated from field: optional raccoonai.Job job = 2;
   */
  job?: JobJson;

  /**
   * The route the job was served on, when ai_verification.route_id is set. Its
   * jobs list is not populated.
   *
   * @generated from field: optional raccoonai.Route route = 3;
   */
  route?: RouteJson;
};

/**
 * Describes the message raccoonai.GovAiVerificationRow.
 * Use `create(GovAiVerificationRowSchema)` to create a new message.
 */
export const GovAiVerificationRowSchema: GenMessage<GovAiVerificationRow, {jsonType: GovAiVerificationRowJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 53);

/**
 * Ordered and paged as AiVerificationListRequest.list_filter asks; the jobs and
 * routes follow whichever verdict rows the page holds.
 *
 * @generated from message raccoonai.GovAiVerificationList
 */
export type GovAiVerificationList = Message<"raccoonai.GovAiVerificationList"> & {
  /**
   * @generated from field: repeated raccoonai.GovAiVerificationRow ai_verifications = 1 [json_name = "ai_verifications"];
   */
  aiVerifications: GovAiVerificationRow[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * Ordered and paged as AiVerificationListRequest.list_filter asks; the jobs and
 * routes follow whichever verdict rows the page holds.
 *
 * @generated from message raccoonai.GovAiVerificationList
 */
export type GovAiVerificationListJson = {
  /**
   * @generated from field: repeated raccoonai.GovAiVerificationRow ai_verifications = 1 [json_name = "ai_verifications"];
   */
  ai_verifications?: GovAiVerificationRowJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.GovAiVerificationList.
 * Use `create(GovAiVerificationListSchema)` to create a new message.
 */
export const GovAiVerificationListSchema: GenMessage<GovAiVerificationList, {jsonType: GovAiVerificationListJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 54);

/**
 * Driver shifts of the caller's geo-scoped service providers, narrowed to shifts
 * that actually served one of the caller's service receivers.
 *
 * @generated from message raccoonai.GovDriverOnShiftListRequest
 */
export type GovDriverOnShiftListRequest = Message<"raccoonai.GovDriverOnShiftListRequest"> & {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequest;

  /**
   * @generated from field: required raccoonai.DateTimeFilter date_time_filter = 2 [json_name = "date_time_filter"];
   */
  dateTimeFilter?: DateTimeFilter;

  /**
   * @generated from field: repeated raccoonai.DriverOnShiftStatus statuses = 3;
   */
  statuses: DriverOnShiftStatus[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * Driver shifts of the caller's geo-scoped service providers, narrowed to shifts
 * that actually served one of the caller's service receivers.
 *
 * @generated from message raccoonai.GovDriverOnShiftListRequest
 */
export type GovDriverOnShiftListRequestJson = {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequestJson;

  /**
   * @generated from field: required raccoonai.DateTimeFilter date_time_filter = 2 [json_name = "date_time_filter"];
   */
  date_time_filter?: DateTimeFilterJson;

  /**
   * @generated from field: repeated raccoonai.DriverOnShiftStatus statuses = 3;
   */
  statuses?: DriverOnShiftStatusJson[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.GovDriverOnShiftListRequest.
 * Use `create(GovDriverOnShiftListRequestSchema)` to create a new message.
 */
export const GovDriverOnShiftListRequestSchema: GenMessage<GovDriverOnShiftListRequest, {jsonType: GovDriverOnShiftListRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 55);

/**
 * Routes of the caller's geo-scoped service providers, narrowed to routes with
 * a job at one of the caller's pickup locations.
 *
 * @generated from message raccoonai.GovRouteListRequest
 */
export type GovRouteListRequest = Message<"raccoonai.GovRouteListRequest"> & {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequest;

  /**
   * @generated from field: required raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetimeFilter?: DateTimeFilter;

  /**
   * @generated from field: repeated raccoonai.RouteStatus route_statuses = 3 [json_name = "route_statuses"];
   */
  routeStatuses: RouteStatus[];

  /**
   * @generated from field: repeated raccoonai.RouteCategory route_categories = 4 [json_name = "route_categories"];
   */
  routeCategories: RouteCategory[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 5 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * Same as RouteListRequest.search: route id, truck plate, driver name.
   *
   * @generated from field: optional string search = 6;
   */
  search: string;

  /**
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * Routes of the caller's geo-scoped service providers, narrowed to routes with
 * a job at one of the caller's pickup locations.
 *
 * @generated from message raccoonai.GovRouteListRequest
 */
export type GovRouteListRequestJson = {
  /**
   * @generated from field: required raccoonai.GovOrganizationRequest filter = 1;
   */
  filter?: GovOrganizationRequestJson;

  /**
   * @generated from field: required raccoonai.DateTimeFilter datetime_filter = 2 [json_name = "datetime_filter"];
   */
  datetime_filter?: DateTimeFilterJson;

  /**
   * @generated from field: repeated raccoonai.RouteStatus route_statuses = 3 [json_name = "route_statuses"];
   */
  route_statuses?: RouteStatusJson[];

  /**
   * @generated from field: repeated raccoonai.RouteCategory route_categories = 4 [json_name = "route_categories"];
   */
  route_categories?: RouteCategoryJson[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 5 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * Same as RouteListRequest.search: route id, truck plate, driver name.
   *
   * @generated from field: optional string search = 6;
   */
  search?: string;

  /**
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.GovRouteListRequest.
 * Use `create(GovRouteListRequestSchema)` to create a new message.
 */
export const GovRouteListRequestSchema: GenMessage<GovRouteListRequest, {jsonType: GovRouteListRequestJson}> = /*@__PURE__*/
  messageDesc(file_gov_dash_service, 56);

/**
 * @generated from service raccoonai.GovDashService
 */
export const GovDashService: GenService<{
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovGeoAccess
   */
  getGovGeoAccess: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof GovGeoAccessListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.ServiceProviders
   */
  serviceProviders: {
    methodKind: "unary";
    input: typeof GovOrganizationRequestSchema;
    output: typeof GovServiceProviderInfoListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.ServiceReceivers
   */
  serviceReceivers: {
    methodKind: "unary";
    input: typeof GovOrganizationRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.PickupLocations
   */
  pickupLocations: {
    methodKind: "unary";
    input: typeof GovPickupLocationListRequestSchema;
    output: typeof GovPickupLocationListSchema;
  },
  /**
   * Container types owned by the service providers in the caller's geo scope,
   * each with its owner organization.
   *
   * @generated from rpc raccoonai.GovDashService.ContainerTypes
   */
  containerTypes: {
    methodKind: "unary";
    input: typeof GovOrganizationRequestSchema;
    output: typeof ContainerTypeListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.DisposalSites
   */
  disposalSites: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.DisposalSiteLocations
   */
  disposalSiteLocations: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof LocationListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.Trucks
   */
  trucks: {
    methodKind: "unary";
    input: typeof GovOrganizationRequestSchema;
    output: typeof GovTruckListSchema;
  },
  /**
   * Active trucks owned by government organizations. Not geo-scoped: every gov user sees all of them.
   *
   * @generated from rpc raccoonai.GovDashService.GovernmentTrucks
   */
  governmentTrucks: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof GovTruckListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.Depots
   */
  depots: {
    methodKind: "unary";
    input: typeof GovOrganizationRequestSchema;
    output: typeof GovDepotInfoListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.Jobs
   */
  jobs: {
    methodKind: "unary";
    input: typeof GovJobListRequestSchema;
    output: typeof JobListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.DriverOnShifts
   */
  driverOnShifts: {
    methodKind: "unary";
    input: typeof GovDriverOnShiftListRequestSchema;
    output: typeof DriverOnShiftListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.Routes
   */
  routes: {
    methodKind: "unary";
    input: typeof GovRouteListRequestSchema;
    output: typeof RouteListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.ExportJobsReport
   */
  exportJobsReport: {
    methodKind: "unary";
    input: typeof GovJobListRequestSchema;
    output: typeof GovJobsReportResponseSchema;
  },
  /**
   * xlsx of the same pickup locations PickupLocations returns for this request.
   *
   * @generated from rpc raccoonai.GovDashService.ExportPickupLocationsReport
   */
  exportPickupLocationsReport: {
    methodKind: "unary";
    input: typeof GovPickupLocationListRequestSchema;
    output: typeof GovJobsReportResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovRawScaleRecordList
   */
  getGovRawScaleRecordList: {
    methodKind: "unary";
    input: typeof GovRawScaleRecordListRequestSchema;
    output: typeof RawScaleRecordListResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetServiceProviderStatsById
   */
  getServiceProviderStatsById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof GovServiceProviderStatsSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetServiceReceiverStatsById
   */
  getServiceReceiverStatsById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof GovServiceReceiverStatsSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetDisposalSiteById
   */
  getDisposalSiteById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetPickupLocationStatsById
   */
  getPickupLocationStatsById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof GovPickupLocationStatsSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetTruckStatsById
   */
  getTruckStatsById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof GovTruckStatsSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetDepotById
   */
  getDepotById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof GovDepotInfoSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetJobById
   */
  getJobById: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof JobSchema;
  },
  /**
   * endpoints based on internal tables, stable structure
   *
   * @generated from rpc raccoonai.GovDashService.GetGovDashboardAnalytics
   */
  getGovDashboardAnalytics: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GovDashboardAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovServiceProviderAnalytics
   */
  getGovServiceProviderAnalytics: {
    methodKind: "unary";
    input: typeof GovServiceProviderAnalyticsRequestSchema;
    output: typeof GovServiceProviderAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovServiceReceiverAnalytics
   */
  getGovServiceReceiverAnalytics: {
    methodKind: "unary";
    input: typeof GovServiceReceiverAnalyticsRequestSchema;
    output: typeof GovServiceReceiverAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovTruckTravelPath
   */
  getGovTruckTravelPath: {
    methodKind: "unary";
    input: typeof GovTruckTravelPathRequestSchema;
    output: typeof GovTruckTravelPathResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.TruckGpsStops
   */
  truckGpsStops: {
    methodKind: "unary";
    input: typeof GovTruckGpsStopsRequestSchema;
    output: typeof GpsStopListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovDepotAnalytics
   */
  getGovDepotAnalytics: {
    methodKind: "unary";
    input: typeof GovDepotAnalyticsRequestSchema;
    output: typeof GovDepotAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovRawScaleAnalytics
   */
  getGovRawScaleAnalytics: {
    methodKind: "unary";
    input: typeof GovRawScaleAnalyticsRequestSchema;
    output: typeof GovRawScaleAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovRawScaleRecordByCompany
   */
  getGovRawScaleRecordByCompany: {
    methodKind: "unary";
    input: typeof GovRawScaleAnalyticsRequestSchema;
    output: typeof GovRawScaleRecordByCompanyResponseSchema;
  },
  /**
   * Suspicious location, new feature during gov dash
   *
   * @generated from rpc raccoonai.GovDashService.SuspiciousLocations
   */
  suspiciousLocations: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof SuspiciousLocationResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.CreateSuspiciousLocation
   */
  createSuspiciousLocation: {
    methodKind: "unary";
    input: typeof LocationCreateSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.UpdateSuspiciousLocation
   */
  updateSuspiciousLocation: {
    methodKind: "unary";
    input: typeof LocationUpdateSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.ArchiveSuspiciousLocation
   */
  archiveSuspiciousLocation: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.UnarchiveSuspiciousLocation
   */
  unarchiveSuspiciousLocation: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof LocationSchema;
  },
  /**
   * Endpoints Based on GPS Stop, might be refactored
   *
   * @generated from rpc raccoonai.GovDashService.GetGovTruckAnalytics
   */
  getGovTruckAnalytics: {
    methodKind: "unary";
    input: typeof GovTruckAnalyticsRequestSchema;
    output: typeof GovTruckAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovPickupLocationAnalytics
   */
  getGovPickupLocationAnalytics: {
    methodKind: "unary";
    input: typeof GovPickupLocationAnalyticsRequestSchema;
    output: typeof GovPickupLocationAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovSuspiciousLocationAnalytics
   */
  getGovSuspiciousLocationAnalytics: {
    methodKind: "unary";
    input: typeof GovSuspiciousLocationAnalyticsRequestSchema;
    output: typeof GovSuspiciousLocationAnalyticsResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.AnomaliesList
   */
  anomaliesList: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GpsStopListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.AnomalieRoute
   */
  anomalieRoute: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof AnomalieRouteResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovAnalyticsDisposalVisitsForAll
   */
  getGovAnalyticsDisposalVisitsForAll: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GovAnalyticsDisposalVisitsForAllSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovAnalyticsLocationVisitsForAll
   */
  getGovAnalyticsLocationVisitsForAll: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GovAnalyticsLocationVisitsForAllSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovAnalyticsAnomaliesForAll
   */
  getGovAnalyticsAnomaliesForAll: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GovAnalyticsAnomaliesForAllSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovDisposalVisits
   */
  getGovDisposalVisits: {
    methodKind: "unary";
    input: typeof GovDashboardAnalyticsRequestSchema;
    output: typeof GovDisposalVisitListSchema;
  },
  /**
   * AI verification verdicts of jobs (see ai_verification.proto). Read-only —
   * the rows are produced by batch checkers — and scoped by the caller's geo
   * access like every other endpoint here. GetAiVerificationByJobId reports a
   * job outside that scope, or one no check has run for, as not found.
   *
   * @generated from rpc raccoonai.GovDashService.GetAiVerificationByJobId
   */
  getAiVerificationByJobId: {
    methodKind: "unary";
    input: typeof AiVerificationByJobRequestSchema;
    output: typeof AiVerificationSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.ListAiVerifications
   */
  listAiVerifications: {
    methodKind: "unary";
    input: typeof AiVerificationListRequestSchema;
    output: typeof GovAiVerificationListSchema;
  },
  /**
   * @generated from rpc raccoonai.GovDashService.GetGovDailySummaries
   */
  getGovDailySummaries: {
    methodKind: "unary";
    input: typeof GovDailySummaryRequestSchema;
    output: typeof GovDailySummaryListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gov_dash_service, 0);

